import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationEN from './locales/en/translation.json';
import translationAR from './locales/ar/translation.json';
import translationKR from './locales/kr/translation.json';

const resources = {
  en: {
    translation: translationEN,
  },
  ar: {
    translation: translationAR,
  },
  kr: {
    translation: translationKR
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'kr', // Default language
    keySeparator: false, // Allow using dots in keys
    interpolation: {
      escapeValue: false, // React already escapes the values
    },
  });

export default i18n;
